import React, { useContext } from "react";

import { OrgRole } from "services/orbac/types";
import { Role } from "services/rbac/types";

import { DatabasePrivileges, PrivilegesErrors, PrivilegesState } from "./types";

type PrivilegesContextType = {
  privilegesState: PrivilegesState & PrivilegesErrors & DatabasePrivileges;
  privilegesDispatch: (action?: any) => void;
  getDiff: (role: Role | OrgRole, forceDatabaseLevel?: boolean) => void;
  validateEmptySections: (options?: {
    catalogName?: string;
    role?: OrgRole | Role;
  }) => Record<string, string[]>;
};

export const PrivilegesContext = React.createContext<PrivilegesContextType>({
  privilegesState: {
    engine: [],
    account: [],
    database: [],
    table: [],
    view: [],
    schema: [],
    login: [],
    organization: [],
    "service account": [],
    role: [],
    "network policy": [],
    databasePrivileges: {},
    permissionErrors: {
      table: [],
      view: [],
      schema: [],
    },
  },
  privilegesDispatch: () => {},
  validateEmptySections: () => ({}),
  getDiff: (_role: Role | OrgRole) => ({ toAssign: [], toRevoke: [] }),
});

export const usePrivilegesState = (): PrivilegesContextType => {
  const context = useContext(PrivilegesContext);
  return context;
};
